import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import './_navs.scss'
import { useHistory, useLocation } from 'react-router-dom';

const routes = [
  {
    name: 'Category',
    path: '/services/hide',
  },
  {
    name: 'Service',
    path: '/services/hide/service',
  },
]

const HideNavs = () => {
  const location = useLocation();
  const history = useHistory();

  return (
    <div className="hide-navs">
      <Nav
        bsStyle="pills"
        className="tabs"
        activeKey={location.pathname}
        onSelect={(path) => history.push(`${path}`)}
      >
        {routes.map((route, index) => (
          <NavItem key={index} eventKey={route.path} title={route.name}>
            {route.name}
          </NavItem>
        ))}
      </Nav>
    </div>
  );
}

export default HideNavs;
